<template>
  <!-- Shown in place of an editor surface when no bundle is active. Authoring
       state lives in a shared workspace singleton that's only persisted once it's
       attached to a library bundle, so we block editing until one exists rather
       than let work land in an unsaved, soon-discarded workspace. -->
  <div class="bundle-gate">
    <font-awesome-icon :icon="['fas', 'box-archive']" class="bundle-gate__icon" />
    <h2 class="bundle-gate__title">No bundle open</h2>
    <p class="bundle-gate__text">
      Create or open a battlepack bundle to start authoring. Your work is saved into the active
      bundle.
    </p>
    <div class="bundle-gate__actions">
      <StButton variant="primary" icon="plus" @click="openNew">New bundle</StButton>
      <StButton variant="secondary" icon="folder-open" @click="onLoad">Open from file…</StButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { StButton } from './ui/index.js';
import { useBundleActions } from '../composables/useBundleActions.js';

const { openNew, onLoad } = useBundleActions();
</script>

<style scoped>
.bundle-gate {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--st-space-3);
  padding: var(--st-space-6);
  text-align: center;
  background: var(--st-canvas);
}
.bundle-gate__icon {
  font-size: 2rem;
  color: var(--st-text-subtle);
}
.bundle-gate__title {
  margin: 0;
  font-family: var(--st-font-display);
  font-size: var(--st-text-lg);
  font-weight: var(--st-weight-semibold);
  color: var(--st-text);
}
.bundle-gate__text {
  margin: 0;
  max-width: 28rem;
  font-size: var(--st-text-sm);
  color: var(--st-text-muted);
}
.bundle-gate__actions {
  display: flex;
  gap: var(--st-space-2);
  margin-top: var(--st-space-2);
}
</style>
